export const translations = {
  ro: {
    // Common
    loading: "Se încarcă...",
    save: "Salvează",
    cancel: "Anulează",
    delete: "Șterge",
    edit: "Editează",
    search: "Caută",
    filter: "Filtrează",
    all: "Toate",
    
    // Navigation
    home: "Acasă",
    ads: "Anunțuri",
    createAd: "Adaugă Anunț",
    myAds: "Anunțurile Mele",
    favorites: "Favorite",
    messages: "Mesaje",
    dashboard: "Panou Control",
    settings: "Setări",
    profile: "Profil",
    logout: "Deconectare",
    login: "Autentificare",
    register: "Înregistrare",
    map: "Hartă",
    blog: "Blog",
    forum: "Forum",
    stories: "Povești de Succes",
    
    // Auth
    email: "Email",
    password: "Parolă",
    confirmPassword: "Confirmă Parola",
    name: "Nume",
    forgotPassword: "Ai uitat parola",
    noAccount: "Nu ai cont?",
    haveAccount: "Ai deja cont?",
    loginButton: "Intră în cont",
    registerButton: "Creează cont",
    orContinueWith: "sau continuă cu",
    auth: {
      loginSuccess: "Autentificare reușită!",
      registerSuccess: "Cont creat cu succes!",
      passwordsNotMatch: "Parolele nu coincid",
      passwordMinLength: "Parola trebuie să aibă cel puțin 5 caractere",
      resetPassword: "Resetează parola",
      enterNewPassword: "Introdu noua ta parolă",
      newPassword: "Parolă nouă",
      backToLogin: "Înapoi la autentificare",
      enterEmailReset: "Introdu adresa de email pentru a primi un link de resetare",
      sendResetLink: "Trimite link de resetare",
      welcomeBack: "Bine ai revenit!",
      createAccount: "Creează un cont",
      loginToContinue: "Intră în cont pentru a continua",
      registerToPost: "Înregistrează-te pentru a posta anunțuri",
      continueWithGoogle: "Continuă cu Google",
      yourName: "Numele tău",
      heroTitle: "Cea mai modernă platformă de anunțuri",
      heroSubtitle: "Vinde rapid, cumpără sigur. Alătură-te comunității X67."
    },
    
    // Ads
    category: "Categorie",
    subcategory: "Subcategorie",
    price: "Preț",
    location: "Locație",
    county: "Județ",
    city: "Localitate",
    title: "Titlu",
    description: "Descriere",
    photos: "Fotografii",
    contactPhone: "Telefon contact",
    contactEmail: "Email contact",
    publishAd: "Publică anunțul",
    editAd: "Editează anunțul",
    deleteAd: "Șterge anunțul",
    shareAd: "Distribuie",
    reportAd: "Raportează anunțul",
    viewAd: "Vezi anunțul",
    similarAds: "Anunțuri similare",
    noAds: "Nu există anunțuri",
    views: "vizualizări",
    postedAt: "Publicat la",
    priceNegotiable: "Preț negociabil",
    priceOnRequest: "Preț la cerere",
    free: "Gratuit",
    negotiable: "neg.",
    verified: "Verificat",
    verifiedSeller: "Vânzător verificat",
    promoted: "Promovat",
    boosted: "Ridicat",
    
    // Categories
    categories: {
      escorts: "Escorte",
      real_estate: "Imobiliare",
      cars: "Auto",
      jobs: "Joburi",
      electronics: "Electronice",
      fashion: "Modă",
      services: "Servicii",
      animals: "Animale"
    },
    
    // Filters
    sortBy: "Sortare",
    newest: "Cele mai noi",
    oldest: "Cele mai vechi",
    priceLowHigh: "Preț crescător",
    priceHighLow: "Preț descrescător",
    mostViewed: "Cele mai văzute",
    
    // Messages
    sendMessage: "Trimite mesaj",
    typeMessage: "Scrie un mesaj...",
    noMessages: "Nu ai mesaje",
    
    // Footer
    termsConditions: "Termeni și Condiții",
    privacyPolicy: "Politica de Confidențialitate",
    faq: "Întrebări Frecvente",
    contact: "Contact",
    aboutUs: "Despre Noi",
    footerDescription: "Cea mai modernă platformă de anunțuri din România. Găsește tot ce ai nevoie, de la imobiliare la auto și servicii.",
    usefulLinks: "Link-uri Utile",
    guides: "Ghiduri",
    communityForum: "Forum Comunitate",
    allRightsReserved: "Toate drepturile rezervate.",
    securePayments: "Plăți securizate prin",
    
    // Misc
    welcome: "Bine ai venit",
    thankYou: "Mulțumim",
    error: "Eroare",
    success: "Succes",
    confirm: "Confirmare",
    areYouSure: "Ești sigur?",
    yes: "Da",
    no: "Nu",
    priceAlerts: "Alerte de Preț",
    sellerStats: "Statistici Vânzător",
    loyaltyPoints: "Puncte Loialitate",
    referralProgram: "Program Referral",
    enableNotifications: "Activează notificările",
    installApp: "Instalează aplicația",
    adminPanel: "Panou Admin",
    
    // Homepage
    heroTitle: "Găsește ce cauți",
    heroSubtitle: "Cel mai mare site de anunțuri gratuite din România",
    searchPlaceholder: "Ce cauți?",
    popularCategories: "Categorii Populare",
    featuredAds: "Anunțuri Promovate",
    recentAds: "Anunțuri Recente",
    findWhatYouNeed: "Găsește exact ce cauți în categoriile noastre",
    popularOffers: "Cele mai populare oferte",
    newestAds: "Cele mai noi anunțuri",
    viewAll: "Vezi toate",
    addFirstAd: "Adaugă primul anunț",
    haveToSell: "Ai ceva de vândut?",
    postInMinutes: "Postează anunțul tău în câteva minute și ajunge la mii de cumpărători potențiali.",
    publishFree: "Publică Gratuit",
    
    // Create Ad
    step1: "Categorie & Locație",
    step2: "Detalii",
    step3: "Fotografii",
    step4: "Confirmare",
    next: "Continuă",
    back: "Înapoi",
    selectCategory: "Selectează categoria",
    selectLocation: "Selectează locația",
    searchLocation: "Caută localitate",
    uploadPhotos: "Încarcă fotografii",
    dragDropPhotos: "Trage fotografiile aici sau click pentru a încărca",
    maxPhotos: "Maxim 10 fotografii",
    
    // Report
    reportTitle: "Raportează Anunțul",
    reportReason: "Motiv",
    reportDescription: "Descriere (opțional)",
    reportReasons: {
      spam: "Spam sau conținut fals",
      inappropriate: "Conținut inadecvat",
      scam: "Tentativă de înșelăciune",
      duplicate: "Anunț duplicat",
      wrongCategory: "Categorie greșită",
      illegal: "Activitate ilegală",
      personalInfo: "Date personale expuse",
      other: "Altul"
    },
    sendReport: "Trimite Raportul",
    reportSent: "Mulțumim! Raportul tău a fost trimis.",
    
    // Map
    mapTitle: "Hartă Anunțuri",
    adsOnMap: "anunțuri pe hartă",
    noAdsOnMap: "Nu am găsit anunțuri cu locație",
    clearFilters: "Șterge filtrele",
    legend: "Legendă"
  },
  
  en: {
    // Common
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    search: "Search",
    filter: "Filter",
    all: "All",
    
    // Navigation
    home: "Home",
    ads: "Ads",
    createAd: "Post Ad",
    myAds: "My Ads",
    favorites: "Favorites",
    messages: "Messages",
    dashboard: "Dashboard",
    settings: "Settings",
    profile: "Profile",
    logout: "Logout",
    login: "Login",
    register: "Register",
    map: "Map",
    blog: "Blog",
    forum: "Forum",
    stories: "Success Stories",
    
    // Auth
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    name: "Name",
    forgotPassword: "Forgot password",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    loginButton: "Sign In",
    registerButton: "Create Account",
    orContinueWith: "or continue with",
    auth: {
      loginSuccess: "Login successful!",
      registerSuccess: "Account created successfully!",
      passwordsNotMatch: "Passwords don't match",
      passwordMinLength: "Password must be at least 5 characters",
      resetPassword: "Reset password",
      enterNewPassword: "Enter your new password",
      newPassword: "New password",
      backToLogin: "Back to login",
      enterEmailReset: "Enter your email to receive a reset link",
      sendResetLink: "Send reset link",
      welcomeBack: "Welcome back!",
      createAccount: "Create an account",
      loginToContinue: "Sign in to continue",
      registerToPost: "Register to post ads",
      continueWithGoogle: "Continue with Google",
      yourName: "Your name",
      heroTitle: "The most modern classified ads platform",
      heroSubtitle: "Sell fast, buy safely. Join the X67 community."
    },
    
    // Ads
    category: "Category",
    subcategory: "Subcategory",
    price: "Price",
    location: "Location",
    county: "County",
    city: "City",
    title: "Title",
    description: "Description",
    photos: "Photos",
    contactPhone: "Contact Phone",
    contactEmail: "Contact Email",
    publishAd: "Publish Ad",
    editAd: "Edit Ad",
    deleteAd: "Delete Ad",
    shareAd: "Share",
    reportAd: "Report Ad",
    viewAd: "View Ad",
    similarAds: "Similar Ads",
    noAds: "No ads found",
    views: "views",
    postedAt: "Posted",
    priceNegotiable: "Negotiable",
    priceOnRequest: "Price on request",
    free: "Free",
    negotiable: "neg.",
    verified: "Verified",
    verifiedSeller: "Verified seller",
    promoted: "Promoted",
    boosted: "Boosted",
    
    // Categories
    categories: {
      escorts: "Escorts",
      real_estate: "Real Estate",
      cars: "Cars",
      jobs: "Jobs",
      electronics: "Electronics",
      fashion: "Fashion",
      services: "Services",
      animals: "Animals"
    },
    
    // Filters
    sortBy: "Sort by",
    newest: "Newest",
    oldest: "Oldest",
    priceLowHigh: "Price: Low to High",
    priceHighLow: "Price: High to Low",
    mostViewed: "Most Viewed",
    
    // Messages
    sendMessage: "Send Message",
    typeMessage: "Type a message...",
    noMessages: "No messages",
    
    // Footer
    termsConditions: "Terms & Conditions",
    privacyPolicy: "Privacy Policy",
    faq: "FAQ",
    contact: "Contact",
    aboutUs: "About Us",
    footerDescription: "The most modern classified ads platform in Romania. Find everything you need, from real estate to cars and services.",
    usefulLinks: "Useful Links",
    guides: "Guides",
    communityForum: "Community Forum",
    allRightsReserved: "All rights reserved.",
    securePayments: "Secure payments via",
    
    // Misc
    welcome: "Welcome",
    thankYou: "Thank you",
    error: "Error",
    success: "Success",
    confirm: "Confirm",
    areYouSure: "Are you sure?",
    yes: "Yes",
    no: "No",
    priceAlerts: "Price Alerts",
    sellerStats: "Seller Stats",
    loyaltyPoints: "Loyalty Points",
    referralProgram: "Referral Program",
    enableNotifications: "Enable notifications",
    installApp: "Install app",
    adminPanel: "Admin Panel",
    
    // Homepage
    heroTitle: "Find what you need",
    heroSubtitle: "The largest free classifieds site in Romania",
    searchPlaceholder: "What are you looking for?",
    popularCategories: "Popular Categories",
    featuredAds: "Featured Ads",
    recentAds: "Recent Ads",
    findWhatYouNeed: "Find exactly what you need in our categories",
    popularOffers: "Most popular offers",
    newestAds: "Latest ads",
    viewAll: "View all",
    addFirstAd: "Add the first ad",
    haveToSell: "Have something to sell?",
    postInMinutes: "Post your ad in minutes and reach thousands of potential buyers.",
    publishFree: "Publish Free",
    
    // Create Ad
    step1: "Category & Location",
    step2: "Details",
    step3: "Photos",
    step4: "Confirmation",
    next: "Continue",
    back: "Back",
    selectCategory: "Select category",
    selectLocation: "Select location",
    searchLocation: "Search location",
    uploadPhotos: "Upload photos",
    dragDropPhotos: "Drag photos here or click to upload",
    maxPhotos: "Maximum 10 photos",
    
    // Report
    reportTitle: "Report Ad",
    reportReason: "Reason",
    reportDescription: "Description (optional)",
    reportReasons: {
      spam: "Spam or false content",
      inappropriate: "Inappropriate content",
      scam: "Scam attempt",
      duplicate: "Duplicate ad",
      wrongCategory: "Wrong category",
      illegal: "Illegal activity",
      personalInfo: "Personal data exposed",
      other: "Other"
    },
    sendReport: "Send Report",
    reportSent: "Thank you! Your report has been submitted.",
    
    // Map
    mapTitle: "Ads Map",
    adsOnMap: "ads on map",
    noAdsOnMap: "No ads with location found",
    clearFilters: "Clear filters",
    legend: "Legend"
  }
};

export const supportedLanguages = [
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'en', name: 'English', flag: '🇬🇧' }
];
